import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, ProgressBar } from '../../components/ui';
import lottie from 'lottie-web';
import faceScanUrl from '../../assets/lottie/face-scan.json?url';

const FACTS = [
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
    ),
    text: 'First impressions form in just 100 milliseconds. Your face is the first thing people see.',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    text: 'Studies show facial symmetry and skin clarity are among the strongest predictors of perceived attractiveness.',
  },
];

export function ScienceScreen() {
  const navigate = useNavigate();
  const { nextStep } = useStore();
  const animationRef = useRef<HTMLDivElement>(null);

  const handleNext = () => {
    nextStep();
    navigate('/onboarding/compliments');
  };

  useEffect(() => {
    if (!animationRef.current) return;
    const animation = lottie.loadAnimation({
      container: animationRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: faceScanUrl,
    });

    return () => animation.destroy();
  }, []);

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={10} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-8">Science-backed self-improvement</h1>

        {/* Lottie animation */}
        <div className="w-56 h-56 mx-auto mb-8 flex items-center justify-center">
          <div
            ref={animationRef}
            className="w-full h-full opacity-90"
            aria-hidden="true"
          />
        </div>

        {/* Facts */}
        <div className="space-y-6">
          {FACTS.map((fact, index) => (
            <div
              key={index}
              className="flex gap-4 p-4 bg-surface rounded-xl border border-default"
            >
              <div className="text-accent flex-shrink-0">{fact.icon}</div>
              <p className="text-sm text-secondary leading-relaxed">{fact.text}</p>
            </div>
          ))}
        </div>
      </div>

      <Button onClick={handleNext} className="mt-8">
        Next
      </Button>
    </div>
  );
}
